module.exports = __webpack_public_path__ + "img/sass.d2081709.png";